import { render, staticRenderFns } from "./contact-detail.vue?vue&type=template&id=d965cd42&scoped=true"
import script from "./contact-detail.vue?vue&type=script&lang=js"
export * from "./contact-detail.vue?vue&type=script&lang=js"
import style0 from "./contact-detail.vue?vue&type=style&index=0&id=d965cd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d965cd42",
  null
  
)

export default component.exports